import { render, staticRenderFns } from "./SaleLeads.info.vue?vue&type=template&id=8c125bc4&scoped=true"
import script from "./SaleLeads.info.vue?vue&type=script&lang=js"
export * from "./SaleLeads.info.vue?vue&type=script&lang=js"
import style0 from "./SaleLeads.info.vue?vue&type=style&index=0&id=8c125bc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c125bc4",
  null
  
)

export default component.exports